const TIMEOUT = 500
const STORAGE_KEY = 'edgePermission'

function heartbeat(hostname) {
  return new Promise((resolve) => {
    const controller = new AbortController()
    const timer = setTimeout(() => { controller.abort(); resolve(false) }, TIMEOUT)
    fetch(`https://${hostname}/edge/health`, { signal: controller.signal, mode: 'cors' })
      .then(res => { clearTimeout(timer); resolve(res.ok) })
      .catch(() => { clearTimeout(timer); resolve(false) })
  })
}

export function hasEdgeServers(profile) {
  const servers = (profile && profile.edgeServers) || []
  return servers.some(s => (s.hostnames || []).length > 0)
}

export async function pingEdgeServers(profile) {
  const servers = (profile && profile.edgeServers) || []
  const allHostnames = servers.reduce((acc, s) => acc.concat(s.hostnames || []), [])

  if (allHostnames.length === 0) {
    return { init: true, available: false, ips: [], needsPermission: false }
  }

  const results = await Promise.all(allHostnames.map(async hostname => ({
    hostname,
    alive: await heartbeat(hostname)
  })))

  const hostnames = results.filter(r => r.alive).map(r => r.hostname)
  console.log('[edge] responsive hostnames:', hostnames)

  return {
    init:          true,
    available:     hostnames.length > 0,
    ips:           hostnames,
    needsPermission: false
  }
}

export function grantEdgePermission() {
  localStorage.setItem(STORAGE_KEY, 'granted')
}

export function skipEdgePermission() {
  localStorage.setItem(STORAGE_KEY, 'skipped')
}

export async function checkEdgeServers(profile) {
  if (!hasEdgeServers(profile)) {
    return { init: true, available: false, ips: [], needsPermission: false }
  }

  const stored = localStorage.getItem(STORAGE_KEY)

  if (stored === 'granted') {
    // user already granted — run heartbeats silently
    return await pingEdgeServers(profile)
  }

  if (stored === 'skipped') {
    // user already skipped — don't ask again
    return { init: true, available: false, ips: [], needsPermission: false }
  }

  // first time — show banner
  return { init: false, available: false, ips: [], needsPermission: true }
}
